//#region redux
import { AppState } from "store";
import { useSelector } from "react-redux";
//#endregion

const useGenericDocumentPermissions = () => {
  const genericDocumentCreator = useSelector((state: AppState) => state.auth.selectedCompany.genericDocumentCreator);
  const genericDocumentViewer = useSelector((state: AppState) => state.auth.selectedCompany.genericDocumentViewer);

  return {
    canCreateGenericDocuments: genericDocumentCreator,
    canViewGenericDocuments: genericDocumentViewer,
  };
};

export default useGenericDocumentPermissions;
